module.exports = __webpack_public_path__ + "static/media/Hbook2.3f4b1e7b.jpg";